import { Reducer } from 'redux';

import { TemplateListState, TemplatesActionTypes } from './types';

export const defaultState: TemplateListState = {
    loadingTemplates: false,
    page: 1,
    limit: 10,
    templatesList: [],
    count: 0,
    DeletingTemplate: false,
    name: null,
    template: null,
    ispublic: false,
    removeScreenshot: true,
    isInfinityScroll: false,
};

const reducer: Reducer = (state: TemplateListState = defaultState, action): TemplateListState => {
    switch (action.type) {
        case TemplatesActionTypes.LOADING_START:
        case TemplatesActionTypes.LOADING_SUCCESS:
        case TemplatesActionTypes.LOADING_ERROR:
        case TemplatesActionTypes.DELETE_START:
        case TemplatesActionTypes.DELETE_SUCCESS:
        case TemplatesActionTypes.DELETE_ERROR:
        case TemplatesActionTypes.DELETE_ARRAY_START:
        case TemplatesActionTypes.DELETE_ARRAY_SUCCESS:
        case TemplatesActionTypes.DELETE_ARRAY_ERROR:
        case TemplatesActionTypes.PREVIEW_START:
        case TemplatesActionTypes.PREVIEW_SUCCESS:
        case TemplatesActionTypes.PREVIEW_ERROR:
        case TemplatesActionTypes.UPDATE_START:
        case TemplatesActionTypes.UPDATE_ERROR:
        case TemplatesActionTypes.SAVE_TEMPLATE_ERROR:
        case TemplatesActionTypes.SAVE_TEMPLATE_START:
        case TemplatesActionTypes.SAVE_TEMPLATE_SUCCESS:
        case TemplatesActionTypes.CHANGE_PAGE:
        case TemplatesActionTypes.SHARE_TEMPLATE_ERROR:
        case TemplatesActionTypes.CREATE_SHARED_TEMPLATE_SUCCESS:
        case TemplatesActionTypes.SET_TEMPLATE_LIST_NAME:
            return { ...state, ...action.payload };
        case TemplatesActionTypes.UPDATE_SUCCESS:
            return {
                ...state,
                ...{ templatesList: action.payload.templatesList },
            };
        case TemplatesActionTypes.SHARE_TEMPLATE_START:
            return {
                ...state,
                ...{ name: action.payload.name, shareIdentifier: '' },
            };
        case TemplatesActionTypes.SHARE_TEMPLATE_SUCCESS:
        case TemplatesActionTypes.CREATE_SHARED_TEMPLATE_START:
            return {
                ...state,
                ...{ shareIdentifier: action.payload.shareIdentifier },
            };
        case TemplatesActionTypes.CLEAR_TEMPLATES: {
            return {
                ...state,
                templatesList: [],
            };
        }
        default:
            return state;
    }
};

export { reducer as templateList };

export default reducer;
